import * as React from 'react';

import { cn } from '../../../src/lib/utils';

export const appWebFileInputClassName =
  'flex h-12 w-full rounded-xl border border-border bg-background px-3 py-3 text-sm text-foreground file:mr-3 file:rounded-lg file:border-0 file:bg-primary file:px-3 file:py-2 file:text-sm file:font-medium file:text-primary-foreground disabled:cursor-not-allowed disabled:opacity-60';

export const AppWebFileInput = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
  ({ className, type = 'file', ...props }, ref) => (
    <input
      type={type}
      className={cn(appWebFileInputClassName, className)}
      ref={ref}
      {...props}
    />
  ),
);

AppWebFileInput.displayName = 'AppWebFileInput';
